import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FraudTaskService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/ListFraudTasks`, { params });
  }

  createTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/FraudTask/CreateTask`, data);
  }

  getBranchComplianceRate(evaluationTaskId): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetBranchComplianceRate?evaluationTaskId=${evaluationTaskId}`);
  }

  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetRelatedAmbassadros`, { params });
  }

  getListTasksByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/ListTasksByAdmin`, { params });
  }

  getQuestionsWithAnswrsByTaskId(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetQuestionsWithAnswrsByTaskId?taskId=${taskId}`);
  }

  getTaskLogs(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetTaskLogs?taskId=${taskId}`);
  }

  removeTask(id: number) {
    return this.http.delete(`${environment.apiUrl}/FraudTask/RemoveTask?id=${id}`,);
  }

  getListTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/ListTasksByAmbassador`, { params });
  }

  getTaskDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetTaskDetails?taskId=${taskId}`);
  }
  getAvailableActions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetAvailableActions?taskId=${taskId}`);
  }
  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/FraudTask/AddTaskComment`, data);
  }
  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/FraudTask/UpdateTaskComment`, data);
  }
  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/FraudTask/DeleteTaskComment?commentId=${commentId}`);
  }


  changeTaskStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/FraudTask/ChangeTaskStatus`, data);
  }

  submitTaskAnswerAsDraft(data: any): any {
    return this.http.post(`${environment.apiUrl}/FraudTask/SubmitTaskAnswerAsDraft`, data);
  }

  submitTaskAnswer(data: any): any {
    return this.http.post(`${environment.apiUrl}/FraudTask/SubmitTaskAnswer`, data);
  }

  getInstitutionsToEscalate(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/FraudTask/GetInstitutionsToEscalate?taskId=${taskId}`);
  }
}
